import Helper from './Helper.js';

class HashHandler {
  constructor() {
    console.log("hashHandler")
    Helper.loadImagesInContainer('.content');
    setTimeout(() => {
      this.scrollToHash();
    }, 2000);

    window.addEventListener("hashchange", () => {
      this.scrollToHash();
    });
  }

  scrollToHash() {
    const url = location.href;
    const id = url.split('#');
    const theId = id[1]
    console.log("hash", theId);

    if (!!theId) {
      if (parseInt(theId) !== 0) {
        let titleId = (parseInt(id[1]));
        console.log("title id", titleId)
        titleId = titleId + 1;
        if (!isNaN(titleId)) {
          const titlesNodeList = document.querySelectorAll('.ns-title-h2');
          const titles = Array.prototype.slice.call(titlesNodeList);
          const title = titles[titleId];
          this.scroller(title, 30);
        } else if (theId.includes('note')) {
          setTimeout(() => {
            const ac = document.querySelector('#' + theId);
            if (ac) {
              const ac_click = ac.querySelector('.js-accordion-toggle');
              if (!!ac_click) ac_click.click();
              setTimeout(() => {
                this.scroller(ac_click, 0);
              }, 500);
            }
          }, 500);
        } else {
          const anchor = document.querySelector('#' + theId);
          if (!!anchor) {
            if (anchor.parentNode.classList.contains('accordion__container')) {
              let accordion = Helper.getParentNodeWithClass(anchor, 'accordion');
              accordion.querySelector('.js-accordion-toggle').click();

              if (accordion.parentNode.classList.contains('accordion__container')) {
                accordion = Helper.getParentNodeWithClass(accordion, 'accordion');
                accordion.querySelector('.js-accordion-toggle').click();
              }
            }
            setTimeout(() => { this.scroller(anchor, 50) }, 1000);
          }
        }
      }
    }
  }


  scroller(el, correction) {
    const bounding = el.getBoundingClientRect();
    window.scrollTo({
      top: (bounding.top + window.scrollY - el.offsetHeight - correction),
      left: 0,
      behavior: 'smooth'
    });
  }

} export default HashHandler;
